import { RegistryItem } from "@schemas/agreements/schema";
import { AgreementTypeEnum, CalculationMethodType } from "__generated__/graphql";
import { QuantityUnit } from "__generated__/enums.ts";

export const ReeferSchema: RegistryItem = {
	[AgreementTypeEnum.Reefer]: {
		defaultValues: {
			calculationMethod: {
				type: CalculationMethodType.QuantityUnit,
				quantityUnit: QuantityUnit.Reefer,
			},
		},
		agreementFields: {
			"agreement.manualActionRequired": { rules: { hidden: true } },
		},
		calculationMethodFields: {
			"calculationMethod.type": { rules: { hidden: true } },
			"calculationMethod.quantityUnit": { rules: { hidden: true } },
		},
	},
};
